module.exports = {
  Mobile: `@media screen and (max-width: 767px)`,
  Tablet: `@media screen and (min-width: 768px) and (max-width: 991px)`,
  Desktop: `@media screen and (min-width: 992px)`
}



// WEBPACK FOOTER //
// ./src/utils/presets.js